import Dashboard from '@/pages/Data/Dashboard';
import Reports from '@/pages/Data/Reports';
import { ApplicationState } from '@/store';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, Route, Switch, useHistory } from 'react-router-dom';
import './style.scss';

const Data: React.FC = () => {
    const strings = useSelector((state: ApplicationState) => state.locale.data);
    const history = useHistory();

    const routes = [
        {
            component: <Dashboard />,
            path: '/data/dashboard',
            title: strings.DATA_PAGE.DASHBOARD,
        },
        {
            component: <Reports />,
            path: '/data/reports',
            title: strings.DATA_PAGE.REPORTS,
        },
    ];

    useEffect(() => {
        const currentRoute = routes.find((route) => route.path === history.location.pathname);

        history.push(currentRoute ? currentRoute.path : routes[0].path);
    }, [history.location]);

    return (
        <div className="data-container">
            <div className="container">
                <header>
                    <ul className="nav data-navigation">
                        {routes.map((route) => (
                            <li className="nav-item" key={route.path}>
                                <NavLink activeClassName="active" className="nav-link" exact to={route.path}>
                                    {route.title}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </header>
                <Switch>
                    {routes.map((route) => (
                        <Route exact key={route.path} path={route.path}>
                            {route.component}
                        </Route>
                    ))}
                </Switch>
            </div>
        </div>
    );
};

export default Data;
